import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import api from '../api';
import './FileUpload.css';

export default function FileUpload({ onUploaded }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const onDrop = useCallback(async (files) => {
    if (files.length === 0) return;
    const file = files[0];

    if (file.size > 120 * 1024 * 1024) {
      alert('Файл слишком большой (макс. 120 МБ)');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setUploading(true);
    setProgress(0);

    try {
      const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (e.total) setProgress(Math.round((e.loaded * 100) / e.total));
        },
      });
      onUploaded(res.data.attachment);
    } catch (err) {
      console.error('Upload error:', err);
      alert('Ошибка загрузки файла');
    } finally {
      setUploading(false);
      setProgress(0);
    }
  }, [onUploaded]);

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    multiple: false,
  });

  return (
    <div {...getRootProps()} className={`file-upload ${isDragActive ? 'dragging' : ''}`}>
      <input {...getInputProps()} />

      <button
        type="button"
        className="file-upload-btn"
        onClick={open}
        disabled={uploading}
        title="Прикрепить файл"
      >
        {uploading ? (
          <span className="file-upload-progress">{progress}%</span>
        ) : (
          '📎'
        )}
      </button>

      {isDragActive && (
        <div className="file-upload-overlay">
          <span>Отпустите файл</span>
        </div>
      )}
    </div>
  );
}
